import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemHelperPermissionRoute: InvariantJiraRoute = {
	name: 'global-settings-system-helper-permission',
	path: '/secure/admin/PermissionHelperAdmin.jspa',
};
